module.exports = __webpack_public_path__ + "img/CM-SS-CA-Chevy-Established.5c364fa5.jpg";